import { isRecord } from "./typeGuards.utils"

export function xErrorCodeOf(error: unknown): string | null {
    if (!isRecord(error) || !("data" in error)) return null
    const { data } = error
    if (data === null || data === undefined) return null
    if (!isRecord(data)) return null
    return typeof data.xErrorCode === "string" ? data.xErrorCode : null
}
